<section *ngIf="show; else contentLoading">
    <app-document-pending></app-document-pending>    
</section>

<ng-template #contentLoading>
    <img class="img-responsive not-found-uoh mx-auto d-block" src="assets/img/loading_uoh.gif" alt="UOH">
</ng-template>